import { type MCPServerInfo } from '../../types';

const MicrosoftGraphAndArmServer: MCPServerInfo = {
  serverId: 'MICROSOFT_GRAPH_AND_ARM',
  name: 'Microsoft Graph and ARM',
  slug: 'microsoft-graph-and-arm',
  description:
    'MCP (Model Context Protocol) server for Microsoft 365. Includes support for Microsoft Graph and Azure Resource Management APIs.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'https://github.com/merill/lokka',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: '@merill/lokka'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['tenantId', 'clientId', 'clientSecret'],
    properties: {
      tenantId: {
        type: 'string',
        description: 'Microsoft Entra tenant ID',
        sensitive: false
      },
      clientId: {
        type: 'string',
        description: 'Application (client) ID registered in Microsoft Entra',
        sensitive: false
      },
      clientSecret: {
        type: 'string',
        description:
          'Client secret of the application registered in Microsoft Entra',
        sensitive: true
      }
    }
  },
  deprecated: true
};

export default MicrosoftGraphAndArmServer;
